import React, { useCallback, useState } from 'react';
import { Button, Dimmer, Loader } from 'semantic-ui-react';
import { useAlert } from 'context/AlertProvider';
import { downloadPDF } from 'services/pdf.service';
import { getMessageFromAxiosError } from 'modules/message-factory/message-factory';
import { getManifestData } from 'services/manifests.service';
import prepareManifestData from 'modules/prepare-manifest-data/prepare-manifest-data';

export default function RequestManifest({
  shipments = [],
  onManifestDownloaded = () => {},
}) {
  const alert = useAlert();
  const [loading, setLoading] = useState(false);

  const handleDownloadManifest = useCallback(
    async (shipments) => {
      try {
        setLoading(true);
        const { data: manifestData } = await getManifestData(shipments);
        await downloadPDF(
          prepareManifestData(manifestData),
          'dropshipments-manifest',
        );
        onManifestDownloaded();
      } catch (error) {
        alert.current.error(getMessageFromAxiosError(error));
      } finally {
        setLoading(false);
      }
    },
    [setLoading, alert, onManifestDownloaded],
  );

  return (
    <>
      <Dimmer active={loading} inverted>
        <Loader>Generando manifiesto…</Loader>
      </Dimmer>
      <Button
        primary
        loading={loading}
        disabled={loading}
        onClick={(event) => handleDownloadManifest(shipments)}
      >
        Generar manifiesto ({shipments.length}{' '}
        {shipments.length === 1 ? 'referencia' : 'referencias'})
      </Button>
    </>
  );
}
